import { render, staticRenderFns } from "./BrokerSummary.vue?vue&type=template&id=6ef8ddfd&scoped=true"
import script from "./BrokerSummary.vue?vue&type=script&lang=js"
export * from "./BrokerSummary.vue?vue&type=script&lang=js"
import style0 from "./BrokerSummary.vue?vue&type=style&index=0&id=6ef8ddfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef8ddfd",
  null
  
)

export default component.exports